import React, { useEffect, useState } from 'react';
import { TableAdmin } from '../../../../../components/TableAdmin';
import {
  FlexDirectionWrapper,
  MainContent,
  SubTitle,
} from '../../../../../components/StyledComponents';
import { ExcelExportAdmin } from '../../../../../components/ExcelExportAdmin';
import { formatDateToBR } from '../../../../../utils/time';
import { SearchInputAdmin } from '../../../../../components/SearchInputAdmin';
import { removeEmpty } from '../../../../../utils/utils';
import { ErroEnvioSASService } from '../../../services/erroEnvioSASService';
import { numberLocale } from '../../../../../utils/mask';

export const GerenciarErroEnvioSAS = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState([]);
  const [inputSearchValue, setInputSearchValue] = useState(null);
  const [paginationFilters, setPaginationFilters] = useState({
    page: 0,
    linesPerPage: 10,
    orderBy: 'total',
    direction: 'DESC',
  });

  const getDataExcel = async () => {
    const bodyParams = removeEmpty({
      oqueVocePrecisa: inputSearchValue,
    });
    const pageFilter = {
      ...paginationFilters,
      page: 0,
      linesPerPage: data.totalElements || 1000,
    };
    const response = await ErroEnvioSASService.findAll(pageFilter, bodyParams);

    return response?.content?.map((r) => ({
      DESCRICAO: r.descricao,
      QUANTIDADE: r.total,
    }));
  };

  const getData = async (source) => {
    const bodyParams = removeEmpty({
      oqueVocePrecisa: inputSearchValue,
    });
    const response = await ErroEnvioSASService.findAll(
      paginationFilters,
      bodyParams,
      source
    );
    setIsLoading(false);
    setData(response);
  };

  const onLinesPerPageChange = (value) => {
    setPaginationFilters({
      ...paginationFilters,
      linesPerPage: value,
      page: 0,
    });
  };

  const handlePageChange = (value) => {
    setIsLoading(true);
    setPaginationFilters({
      ...paginationFilters,
      page: value,
    });
  };

  const handleOrderClick = ({ orderBy, direction }) => {
    setPaginationFilters({
      ...paginationFilters,
      orderBy: orderBy,
      direction: direction,
    });
  };

  const handleInputPageChange = (newValue) => {
    setIsLoading(true);
    setPaginationFilters({
      ...paginationFilters,
      page: newValue,
    });
  };

  useEffect(() => {
    setIsLoading(true);
    setData([]);
    getData();
    // https://github.com/facebook/create-react-app/issues/6880
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paginationFilters, inputSearchValue]);

  const tableColumns = [
    {
      field: 'descricao',
      id: 'descricao',
      label: 'Descrição',
      minWidth: 10,
      align: 'left',
      columnStyle: {
        overflowWrap: 'break-word',
        width: 900,
        wordBreak: 'break-word',
        whiteSpace: 'break-spaces',
      },
    },
    {
      field: 'total',
      id: 'total',
      label: 'Quantidade',
      minWidth: 100,
      align: 'center',
    },
  ];

  return (
    <MainContent>
      <SubTitle>
        <>
          <h3>Gerenciar</h3>
          <SearchInputAdmin
            value={inputSearchValue}
            onChange={setInputSearchValue}
          />
        </>
      </SubTitle>

      <FlexDirectionWrapper
        style={{ justifyContent: 'space-between', marginTop: '12px' }}
      >
        <div>
          <p style={{ fontWeight: 'bold', color: '#0061C6' }}>
            {numberLocale(data?.totalElements)}{' '}
            <strong className="find-results">
              {' '}
              {data?.totalElements ? 'resultados encontrados' : ''}{' '}
            </strong>
          </p>
        </div>

        <ExcelExportAdmin
          filename={`Exportacao_Erro_Envio_SAS_${formatDateToBR(new Date())}`}
          handleDataCallback={getDataExcel}
          isCsv
        />
      </FlexDirectionWrapper>

      <TableAdmin
        data={data}
        columnAction={'actions'}
        paginationFilters={paginationFilters}
        linesPerPageFilters={paginationFilters?.linesPerPage}
        pagination={true}
        totalPages={data?.totalPages}
        columns={tableColumns}
        isLoading={isLoading}
        tableColor={'#0061C6'}
        lineColor={'rgba(0, 97, 198, 0.1)'}
        onLinesPerPageChange={onLinesPerPageChange}
        onPagePreviousChange={handlePageChange}
        onPageNextChange={handlePageChange}
        handleOrderClick={handleOrderClick}
        onInputPageChange={handleInputPageChange}
      />
    </MainContent>
  );
};
